import React, { useState} from 'react';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { genderOptions, raceOptions, majorOptions } from '../../data/formOptions';
import { VisibilityIcon,  VisibilityOffIcon} from '../../data/icons';
import { useNavigate } from 'react-router-dom';
import { url } from "../../data/url";

const StudentSignUpPage = ({ handleServerError, showToast }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);
  const history = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    dob: '',
    password: '',
    confirmPassword: '',
    race: '',
    major: '',
    schoolName: '',
    userType: "jobSeeker",
  });
  const [formErrors, setFormErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    gender: '',
    dob: '',
    password: '',
    confirmPassword: '',
    race: '',
    major: '',
    schoolName: '',
  });


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: '',
    });
  };
  
  const togglePasswordVisibility = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword);
    } else if (field === 'confirmPassword') {
      setshowConfirmPassword(!showConfirmPassword);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleServerError(''); // Clear any previous server errors
    if (validateForm()) {
      try {
        const response = await fetch(`${url.path}/signup`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (response.ok) {
          console.log('Signup successful:', data.message);
          resetForm();
          showToast(`Account created, redirecting to login in ${countdown} seconds...`);
          
          // Start countdown and redirect after 5 seconds
          const timer = setInterval(() => {
            setCountdown((prevCountdown) => {
              if (prevCountdown === 1) {
                clearInterval(timer);
                history("/signin");
              }
              return prevCountdown - 1;
            });
          }, 1000);
          // You might want to redirect the user or show a success message here
        } else {
          // Handle server-side validation errors or other issues
          handleServerError(data.message || 'An error occurred during signup');
        }
      } catch (error) {
        if(error.response && error.response.status === 409) {
          handleServerError('Email already exists, redirect to login');
        }
        else {
        console.error('Error during signup:', error);
        handleServerError('An error occurred. Please try again later.');
        }
      }
    } else {
      console.log('Form contains errors. Cannot submit.');
    }
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    // Validate each field
    if (formData.firstName.trim() === '') {
      errors.firstName = 'First Name is required';
      valid = false;
    }
    if (formData.lastName.trim() === '') {
      errors.lastName = 'Last Name is required';
      valid = false;
    }
    if (!formData.email.includes('@')) {
      errors.email = 'Invalid email format';
      valid = false;
    }
    if (formData.phoneNumber.trim() === '') {
      errors.phoneNumber = 'Phone Number is required';
      valid = false;
    }
    if (formData.gender === '') {
      errors.gender = 'Gender is required';
      valid = false;
    }
    if (formData.dob === '') {
      errors.dob = 'Date of Birth is required';
      valid = false;
    }
    if (formData.password.length < 8) {
      errors.password = 'Password must be at least 8 characters long';
      valid = false;
    }
    if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = 'Passwords do not match';
      valid = false;
    }
    if (formData.race === '') {
      errors.race = 'Race is required';
      valid = false;
    }
    if (formData.major === '') {
      errors.major = 'Major is required';
      valid = false;
    }
    if (formData.schoolName.trim() === '') {
      errors.major = 'School name is required';
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const resetForm = () => {
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      gender: '',
      dob: '',
      password: '',
      confirmPassword: '',
      race: '',
      major: '',
      schoolName: '',
      userType: "jobSeeker",
    });
    setFormErrors({
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      gender: '',
      dob: '',
      password: '',
      confirmPassword: '',
      race: '',
      major: '',
      schoolName: '',
    });
  };

  return (

      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
          {formErrors.firstName && <span className="error">{formErrors.firstName}</span>}
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
          {formErrors.lastName && <span className="error">{formErrors.lastName}</span>}
        </div>
        <div className="input-group">
          <input
            type="email"
            name="email"
            placeholder="Email Id"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        {formErrors.email && <span className="error">{formErrors.email}</span>}
        <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Gender</option>
            {genderOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {formErrors.gender && <span className="error">{formErrors.gender}</span>}
        </div>
        <div className="input-group">
        <div className="phone-input-container">
          <PhoneInput
            international
            defaultCountry="US"
            value={formData.phoneNumber}
            onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
            placeholder="Phone Number"
          />
          </div>
          {formErrors.phoneNumber && <span className="error">{formErrors.phoneNumber}</span>}
          <div className="dob-input-container">
        <DatePicker
          name="dob"
          selected={formData.dob}
          onSelect={(date) => setFormData({ ...formData, dob: format(new Date(date), 'MM/dd/yyyy') })}
          onChange={(date) => setFormData({ ...formData, dob: format(new Date(date), 'MM/dd/yyyy') })}
          placeholderText="DOB - MM/DD/YYYY"
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={100}
          required
          maxDate={new Date()}
        />
        <span className="datepicker-icon">📅</span>
        </div>
          {formErrors.dob && <span className="error">{formErrors.dob}</span>}
        </div>
        <div className="input-group">
          <div className="password-group">
            <div className="password-group-container">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span 
                className="visibility-icon" 
                onClick={() => togglePasswordVisibility('password')}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </span>
              </div>
            {formErrors.password && <span className="error">{formErrors.password}</span>}
          </div>
          <div className="password-group">
          <div className="password-group-container">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
            />
            <span 
                className="visibility-icon" 
                onClick={() => togglePasswordVisibility('confirmPassword')}
              >
                {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </span>
              </div>
            {formErrors.confirmPassword && <span className="error">{formErrors.confirmPassword}</span>}
          </div>
        </div>
        <div className="input-group">
          <select
            name="race"
            value={formData.race}
            onChange={handleInputChange}
            required
          >
            <option value="">Select your race</option>
            {raceOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {formErrors.race && <span className="error">{formErrors.race}</span>}
          <select
            name="major"
            value={formData.major}
            onChange={handleInputChange}
            required
          >
            <option value="">Select your major</option>
            {majorOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {formErrors.major && <span className="error">{formErrors.major}</span>}
        </div>
        <div className="input-group">
          <input
            type="text"
            name="schoolName"
            placeholder="School"
            value={formData.schoolName}
            onChange={handleInputChange}
            required
          />
          {formErrors.schoolName && <span className="error">{formErrors.schoolName}</span>}
        </div>
        <button type="submit">Sign Up</button>
      </form>
          
  );
}


export default StudentSignUpPage;